import React from 'react';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import { ThankYouTitle } from '../../atoms/thank-you-title/thank-you-title.atom';

export const ThankYouHeader: React.FC = () => {
  return (
    <ThankYouContainer
      padding="1.5rem 0"
      style={{
        display: 'flex',
        justifyContent: 'center',
        borderBottom: '1px solid #e5e7eb',
      }}
    >
      <ThankYouTitle size="1.75rem" color="#6d28d9" weight="700">
        VENDEPAY
      </ThankYouTitle>
    </ThankYouContainer>
  );
};